/**
 * @param {string} flagKey
 * @param {boolean|string|Object} defaultValue
 * @returns {boolean|string|Object}
 */
const getFeatureFlag = (flagKey, defaultValue = false) => {
	const flags = global.SERVER_JS_GLOBAL?.BA_FEATURE_FLAGS || {};
	return flags[flagKey] ?? defaultValue;
};

module.exports = {
	getFeatureFlag,
};
